import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { useApi } from '../composables/useApi';
import { IOutletDetailResponse, OutletDetail } from '../models/outlet-detail';
import { StandardResponse } from '../models/shared/common';
import { RoutesApi } from '../shared/constants/route';

type OutletState = {
  setState: <K extends keyof OutletState>(
    key: K,
    value: OutletState[K]
  ) => void;
  isLoading: boolean;
  dataOutlet: OutletDetail | null;

  getOutlet: (outlet_id: string) => Promise<void>;
};

export const useOutletStore = create<OutletState>()(
  immer((set, get) => ({
    setState: <K extends keyof OutletState>(key: K, value: OutletState[K]) =>
      set({ [key]: value }),
    isLoading: false,
    dataOutlet: null,

    getOutlet: async (outlet_id: string) => {
      const api = useApi();
      const routesApi = RoutesApi();
      const url = api.buildUrl(
        routesApi.OUTLET.GET_OUTLET_DETAIL + `?outlet_id=${outlet_id}`,
        'healthcareIntelligence'
      );
      const resp =
        await api.healthcareIntelligence.get<StandardResponse<OutletDetail>>(
          url
        );
      const data = resp.data;
      set({ dataOutlet: data });
    },
  }))
);
